import React, { useEffect, useState } from "react";
import moment from "moment";
import { useParams } from "react-router-dom";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import { Content, ContentLoader, Alert, Row, Col, Card, CardHeader, CardBody, Table } from "@webtypen/react-components";
import { Page } from "../../components/Page";
import { ApiHelper } from "../../helpers";

export const ContractsDetails = () => {
    const params = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState(null);

    const load = (callback) => {
        setIsLoading(true);
        ApiHelper.request("/api/contracts/data", {
            _id: params.id,
            details: true,
        })
            .then((response) => {
                setData(response.status === "success" && response.data && response.data._id ? response.data : null);
                setIsLoading(false);

                if (callback) {
                    callback(response);
                }
            })
            .catch((e) => {
                console.error(e);
                setData(null);
                setIsLoading(false);

                if (callback) {
                    callback(e.data);
                }
            });
    };

    useEffect(() => {
        load();
    }, [params.id]);

    if (isLoading || !data) {
        return (
            <Page icon={faFileContract} title="Auftrag" back="/contracts">
                <Content>
                    {isLoading ? <ContentLoader /> : <Alert danger>Fehler beim Laden des Datensatzes ...</Alert>}
                </Content>
            </Page>
        );
    }

    return (
        <Page
            icon={faFileContract}
            title={"Auftrag #" + data.number + (data.date ? " - " + moment(data.date).format("DD.MM.YYYY") : "")}
            back="/contracts"
        >
            <Content>
                <Row>
                    <Col width={4}>
                        <Card>
                            <CardHeader>Adresse</CardHeader>
                            <CardBody>
                                {data.address_street ? (
                                    <>
                                        {data.address_street}
                                        <br />
                                    </>
                                ) : null}
                                {data.address_zip || data.address_city ? (
                                    <>
                                        {data.address_zip ? data.address_zip + " " : ""}
                                        {data.address_city ? data.address_city : ""}
                                        <br />
                                    </>
                                ) : null}
                            </CardBody>
                        </Card>
                    </Col>

                    <Col width={8}>
                        <Card>
                            <CardHeader>Schichten / Arbeitszeiten</CardHeader>
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Datum</th>
                                        <th>Von</th>
                                        <th>Bis</th>
                                        <th>Mitarbeiter</th>
                                        <th>Typ</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!data || !data.shifts || data.shifts.length < 1 ? (
                                        <tr>
                                            <td colSpan={5} style={{ padding: 30, userSelect: "none", opacity: 0.7 }}>
                                                Es wurden noch keine Schichten / Arbeitszeiten geplant ...
                                            </td>
                                        </tr>
                                    ) : (
                                        data.shifts.map((shift, i) => (
                                            <tr key={i}>
                                                <td>{shift.date ? moment(shift.date).format("DD.MM.YYYY") : "-"}</td>
                                                <td>{shift.begin_planned ? shift.begin_planned : "-"}</td>
                                                <td>{shift.end_planned ? shift.end_planned : "-"}</td>
                                                <td>
                                                    {shift.is_free
                                                        ? shift.employee_name
                                                            ? shift.employee_name
                                                            : "-"
                                                        : shift.employee_object && shift.employee_object._id
                                                        ? shift.employee_object.firstname +
                                                          " " +
                                                          shift.employee_object.lastname
                                                        : "-"}
                                                </td>
                                                <td>
                                                    {shift.type_object && shift.type_object.name
                                                        ? shift.type_object.name
                                                        : "-"}
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </Card>
                    </Col>
                </Row>
            </Content>
        </Page>
    );
};
